import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AjaxResultType } from '@shared/itcore/itcore.model';
import { itcoreService } from '@shared/itcore/services/itcore.service';
import { NzModalComponent } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-file-list-show',
  template: `
    <div>
      <nz-modal
        #fileModalF
        [(nzVisible)]="visible"
        [nzTitle]="modalTitle"
        [nzContent]="modalContent"
        [nzFooter]="null"
        [nzWidth]="620"
        (nzOnCancel)="close()"
      >
        <ng-template #modalTitle>
          {{ title }}
        </ng-template>
        <ng-template #modalContent>
          <div class="appfile-box">
            <nz-upload
              nzListType="picture"
              [(nzFileList)]="fileList"
              [nzShowUploadList]="{ showRemoveIcon: false, showPreviewIcon: true, showDownloadIcon: true }"
              [nzPreview]="previewFile"
              [nzDownload]="download"
            >
              <!-- <button nz-button><i nz-icon nzType="upload"></i>Upload</button> -->
            </nz-upload>
          </div>
        </ng-template>

        <ng-template #modalFooter>
          <button nz-button nzType="default" (click)="close()">关闭</button>
          <button nz-button nzType="primary" (click)="submit()">确认</button>
        </ng-template>
      </nz-modal>
    </div>
  `,
  styles: [
    `
      .appfile-box {
        margin-bottom: 20px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListShowComponent implements OnInit {
  constructor(private itcore: itcoreService) { }

  title = '查看附件';

  visible: boolean;

  fileList: NzUploadFile;

  @ViewChild('fileModalF', { static: false }) fileModalF: NzModalComponent;
  ngOnInit() { }

  // 预览事件
  previewFile = (file: NzUploadFile) => {
    this.DownloadOrOnLine(file, 'online');
  };
  // 下载事件
  download = (file: NzUploadFile) => {
    console.log(file);
    this.DownloadOrOnLine(file, 'download');
  };

  /** 获取在线预览文件链接 */
  DownloadOrOnLine(file, type: 'download' | 'online'): void {
    if (type === 'online') {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = 'https://view.ekuaibao.com/view/url?url=' + file.url;
      a.click();
    } else {
      const a = document.createElement('a');
      a.target = '_blank';
      a.download = file.name;
      a.href = file.url;
      a.click();
    }
  }

  open(fileJson: string) {
    if (!fileJson) {
      this.itcore.msgSrv.error('未找到附件！');
      return;
    }
    const EnclosureList = JSON.parse(fileJson);

    this.fileList = EnclosureList.map((x) => {
      return {
        uid: '-1',
        name: x.FileName + '.' + x.FileType,
        status: 'done',
        url: x.FileUrl,
      };
    });

    this.fileModalF.open();
  }

  close() {
    // 关闭的时候清空列表
    this.fileModalF.close();
  }

  reset() { }
  submit() { }
}
